export const questionsHistoryOngoing = {
  status: 'success',
  data: {
    current_page: 1,
    total_pages: 1,
    tutor_question_cash_value: 1.0,
    tutor_question_cash_value_currency: 'NT$ ',
    questions: [
      {
        id: 184145,
        description: 'Tttt',
        pubnub_channel_name: 'Question_room_tw_184145',
        pubnub_channel_name_of_competition: 'competition_room_tw_184145',
        pubnub_channel_name_of_matching: 'matching_room_tw_184145',
        asked_by: {
          id: 131159,
          snapask_uid: 131159,
          answer_count: 0,
          role: {
            id: 4,
            name: 'Student',
            display_name: null,
          },
          profile_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/missing_image/avatar/img_default_profile.png',
          is_default_avatar: true,
          average_rate: 0.0,
          instructor_ids: [],
          since_date: '2022-03-03',
          email: 'tw_stu_8978_01@snapask.demo',
          username: 'tw_stu_8978_01',
          display_name: 'tw_stu_8978_01',
          school_name: '市立西松高中',
        },
        answered_by: {
          id: 131065,
          snapask_uid: 131065,
          answer_count: 47,
          role: {
            id: 3,
            name: 'Tutor',
            display_name: null,
          },
          profile_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/users/profile_pics/000/131/065/original/new_profile_pic?1646122915',
          is_default_avatar: false,
          average_rate: 0.0,
          instructor_ids: [],
          since_date: '2022-03-01',
          email: 'tw_tut_8927_01@snapask.demo',
          username: 'tw_tut_8927_01',
          display_name: 'tw_tut_8927_01',
          school_name: '',
        },
        curriculum: {
          id: 14,
          name: '國中',
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/curriculums/icon_pics/000/000/014/medium/ic_curr_tw_%E6%9C%83%E8%80%83.png?1513931938',
        },
        subject: {
          id: 88,
          abbr: 'Math',
          description: '數學',
          minimum_credits_required: 10,
          bg_color: '#888888',
          icon_color: '#ffffff',
          text_color: '#000000',
          is_default: false,
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/subjects/icon_pics/000/000/088/medium/88_math.png?1485146262',
          topic_count: 0,
          is_show_quizzes: true,
          subject_group_ids: [],
          ask_type: 'normal',
          can_compete: false,
        },
        aasm_state: 'on_going',
        endorsement_state: 'not_yet_endorsed',
        answer_stage: 1,
        current_stage_expired_at: null,
        updated_at: '2022-05-30 17:14:08 +0800',
        created_at: '2022-03-03 17:56:57 +0800',
        quiz_id: null,
        quiz_answer: -1,
        user_rating: null,
        user_rating_comment: null,
        user_rating_messages: null,
        picture_url: null,
        picture_thumb_url: null,
        picture_medium_url: null,
        picture_large_url: null,
        audio_record_url: null,
        audio_length: null,
        topic_name: null,
        topic_id: null,
        latest_message: {
          id: 1681633,
          mtype: 'text',
          description: '（未找到訊息）',
          snapask_uid: 131065,
          question_id: 184145,
          updated_at: '2022-05-30 17:14:08 +0800',
          created_at: '2022-05-30 17:14:08 +0800',
          picture_url: null,
          picture_thumb_url: null,
          picture_medium_url: null,
          picture_large_url: null,
          audio_record_url: '',
          message_action: 'content',
          buttons: {},
          reply_to: null,
        },
        is_read: true,
        is_invalid: false,
        reject_remaining_count: 3,
        ask_type: 'to_open',
        expected_cancel_at: null,
        tutor_defined_subtopics: [],
        is_subtopic_taggable: false,
        subtopic_taggable_deadline: null,
        type: 'normal',
        starts_at: null,
        ends_at: null,
        last_active_at: '2022-05-30 17:14:08 +0800',
        competition_info: {
          competition_tutor_count: 0,
          answer_options_count: 0,
          competition_answers: [],
          competition_answers_type: 'alphabet',
          competition_end_time: null,
          tutor_competition_answered_status: null,
        },
        matching_info: {
          matching_end_at: '2022-03-03 17:59:42 +0800',
          matching_candidates_pics: [
            {
              id: 131065,
              profile_pic_url:
                'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/users/profile_pics/000/131/065/thumb/new_profile_pic?1646122915',
            },
          ],
          tutor_matching_state: 'matching_end',
        },
        is_auto_set_public: true,
        auto_set_public_at: '2022-03-03 17:58:57 +0800',
      },
      {
        id: 184469,
        description: 'Merry ',
        pubnub_channel_name: 'Question_room_tw_184469',
        pubnub_channel_name_of_competition: 'competition_room_tw_184469',
        pubnub_channel_name_of_matching: 'matching_room_tw_184469',
        asked_by: {
          id: 131653,
          snapask_uid: 131653,
          answer_count: 0,
          role: {
            id: 4,
            name: 'Student',
            display_name: null,
          },
          profile_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/missing_image/avatar/img_default_profile.png',
          is_default_avatar: true,
          average_rate: 0.0,
          instructor_ids: [],
          since_date: '2022-05-10',
          email: 'tw_stu_9386_04@snapask.demo',
          username: 'tw_stu_9386_04',
          display_name: 'tw_stu_9386_04',
          school_name: '',
        },
        answered_by: {
          id: 131065,
          snapask_uid: 131065,
          answer_count: 47,
          role: {
            id: 3,
            name: 'Tutor',
            display_name: null,
          },
          profile_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/users/profile_pics/000/131/065/original/new_profile_pic?1646122915',
          is_default_avatar: false,
          average_rate: 0.0,
          instructor_ids: [],
          since_date: '2022-03-01',
          email: 'tw_tut_8927_01@snapask.demo',
          username: 'tw_tut_8927_01',
          display_name: 'tw_tut_8927_01',
          school_name: '',
        },
        curriculum: {
          id: 128,
          name: '特考專區',
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/missing_image/curriculum_icon_pic/ic_curr_default_placeholder.png',
        },
        subject: {
          id: 484,
          abbr: 'civil',
          description: '台灣中油專區',
          minimum_credits_required: 0,
          bg_color: '#ffffff',
          icon_color: '#000000',
          text_color: '#000000',
          is_default: false,
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/missing_image/subject_icon_pic/ic-subject-default.png',
          topic_count: 2,
          is_show_quizzes: true,
          subject_group_ids: [],
          ask_type: 'normal',
          can_compete: false,
        },
        aasm_state: 'on_going',
        endorsement_state: 'not_yet_endorsed',
        answer_stage: 1,
        current_stage_expired_at: null,
        updated_at: '2022-05-12 11:21:49 +0800',
        created_at: '2022-05-12 11:21:01 +0800',
        quiz_id: null,
        quiz_answer: -1,
        user_rating: null,
        user_rating_comment: null,
        user_rating_messages: null,
        picture_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/questions/pictures/000/184/469/original/picture?1652325658',
        picture_thumb_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/questions/pictures/000/184/469/thumb/picture?1652325658',
        picture_medium_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/questions/pictures/000/184/469/medium/picture?1652325658',
        picture_large_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/questions/pictures/000/184/469/large/picture?1652325658',
        audio_record_url: null,
        audio_length: null,
        topic_name: null,
        topic_id: null,
        latest_message: null,
        is_read: true,
        is_invalid: false,
        reject_remaining_count: 3,
        ask_type: 'to_open',
        expected_cancel_at: null,
        tutor_defined_subtopics: [],
        is_subtopic_taggable: false,
        subtopic_taggable_deadline: null,
        type: 'normal',
        starts_at: null,
        ends_at: null,
        last_active_at: '2022-05-12 11:21:48 +0800',
        competition_info: {
          competition_tutor_count: 0,
          answer_options_count: 0,
          competition_answers: [],
          competition_answers_type: 'alphabet',
          competition_end_time: null,
          tutor_competition_answered_status: null,
        },
        matching_info: {
          matching_end_at: '2022-05-12 11:21:42 +0800',
          matching_candidates_pics: [
            {
              id: 131065,
              profile_pic_url:
                'https://s3-ap-southeast-1.amazonaws.com/attachments.test-consolidation.appedu.co/users/profile_pics/000/131/065/thumb/new_profile_pic?1646122915',
            },
          ],
          tutor_matching_state: 'matching_end',
        },
        is_auto_set_public: false,
        auto_set_public_at: '2022-05-12 11:23:01 +0800',
      },
    ],
  },
};

export const questionsHistoryMatching = {
  status: 'success',
  data: {
    current_page: 1,
    total_pages: 1,
    tutor_question_cash_value: 15.0,
    tutor_question_cash_value_currency: 'NT$ ',
    questions: [
      {
        id: 3760948,
        description: '我想知道詳細解說和觀念',
        pubnub_channel_name: 'Question_room_tw_3760948',
        pubnub_channel_name_of_competition: 'competition_room_tw_3760948',
        pubnub_channel_name_of_matching: 'matching_room_tw_3760948',
        asked_by: {
          id: 3230728,
          snapask_uid: 3230728,
          answer_count: 0,
          role: { id: 4, name: 'Student', display_name: null },
          profile_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/users/profile_pics/003/230/728/original/new_profile_pic?1653922972',
          is_default_avatar: false,
          average_rate: 0.0,
          instructor_ids: [],
          since_date: '2022-05-30',
          email: 'peggy9453@gmail.com',
          username: 'Vio05',
          display_name: 'Violetta',
          school_name: '市立高雄女中',
        },
        answered_by: null,
        curriculum: {
          id: 10,
          name: '高中',
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/curriculums/icon_pics/000/000/010/medium/ic_curr_tw_%E5%AD%B8%E6%B8%AC.png?1482128121',
        },
        subject: {
          id: 16,
          abbr: 'Math',
          description: '數學',
          minimum_credits_required: 40,
          bg_color: '#308cfd',
          icon_color: '#000000',
          text_color: '#000000',
          is_default: false,
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/subjects/icon_pics/000/000/016/medium/16_math.png?1484902736',
          topic_count: 4,
          is_show_quizzes: true,
          subject_group_ids: [],
          ask_type: 'normal',
          can_compete: true,
        },
        aasm_state: 'open',
        endorsement_state: 'not_yet_endorsed',
        answer_stage: 0,
        current_stage_expired_at: null,
        updated_at: '2022-05-30 23:01:30 +0800',
        created_at: '2022-05-30 23:01:29 +0800',
        quiz_id: null,
        quiz_answer: -1,
        user_rating: null,
        user_rating_comment: null,
        user_rating_messages: null,
        picture_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/760/948/original/picture?1653922887',
        picture_thumb_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/760/948/thumb/picture?1653922887',
        picture_medium_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/760/948/medium/picture?1653922887',
        picture_large_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/760/948/large/picture?1653922887',
        audio_record_url: null,
        audio_length: null,
        topic_name: null,
        topic_id: null,
        latest_message: null,
        is_read: true,
        is_invalid: false,
        reject_remaining_count: 3,
        ask_type: 'to_open',
        expected_cancel_at: null,
        tutor_defined_subtopics: [],
        is_subtopic_taggable: true,
        subtopic_taggable_deadline: null,
        type: 'normal',
        starts_at: null,
        ends_at: null,
        last_active_at: '2022-05-30 23:01:30 +0800',
        competition_info: {
          competition_tutor_count: 0,
          answer_options_count: 0,
          competition_answers: [],
          competition_answers_type: 'alphabet',
          competition_end_time: null,
          tutor_competition_answered_status: null,
        },
        matching_info: {
          matching_end_at: null,
          matching_candidates_pics: [],
          tutor_matching_state: 'not_yet_join',
        },
        is_auto_set_public: false,
        auto_set_public_at: '2022-05-30 23:16:29 +0800',
      },
      {
        id: 3759894,
        description: '我想知道正確解答',
        pubnub_channel_name: 'Question_room_tw_3759894',
        pubnub_channel_name_of_competition: 'competition_room_tw_3759894',
        pubnub_channel_name_of_matching: 'matching_room_tw_3759894',
        asked_by: {
          id: 3230204,
          snapask_uid: 3230204,
          answer_count: 0,
          role: { id: 4, name: 'Student', display_name: null },
          profile_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/missing_image/avatar/img_default_profile.png',
          is_default_avatar: true,
          average_rate: 0.0,
          instructor_ids: [],
          since_date: '2022-05-30',
          email: 'n0982534688@gmail.com',
          username: 'n0982534688',
          display_name: 'n0982534688',
          school_name: '國立北科附工',
        },
        answered_by: null,
        curriculum: {
          id: 10,
          name: '高中',
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/curriculums/icon_pics/000/000/010/medium/ic_curr_tw_%E5%AD%B8%E6%B8%AC.png?1482128121',
        },
        subject: {
          id: 17,
          abbr: 'Physics',
          description: '物理',
          minimum_credits_required: 40,
          bg_color: '#ff2a6b',
          icon_color: '#ffffff',
          text_color: '#000000',
          is_default: null,
          icon_pic_url:
            'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/subjects/icon_pics/000/000/017/medium/17_physics.png?1484902842',
          topic_count: 0,
          is_show_quizzes: true,
          subject_group_ids: [],
          ask_type: 'normal',
          can_compete: true,
        },
        aasm_state: 'open',
        endorsement_state: 'not_yet_endorsed',
        answer_stage: 0,
        current_stage_expired_at: null,
        updated_at: '2022-05-30 10:21:47 +0800',
        created_at: '2022-05-30 10:21:47 +0800',
        quiz_id: null,
        quiz_answer: -1,
        user_rating: null,
        user_rating_comment: null,
        user_rating_messages: null,
        picture_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/759/894/original/picture?1653877306',
        picture_thumb_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/759/894/thumb/picture?1653877306',
        picture_medium_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/759/894/medium/picture?1653877306',
        picture_large_url:
          'https://s3-ap-southeast-1.amazonaws.com/attachments.api.snapask.co/questions/pictures/003/759/894/large/picture?1653877306',
        audio_record_url: null,
        audio_length: null,
        topic_name: null,
        topic_id: null,
        latest_message: null,
        is_read: true,
        is_invalid: false,
        reject_remaining_count: 3,
        ask_type: 'to_open',
        expected_cancel_at: null,
        tutor_defined_subtopics: [],
        is_subtopic_taggable: false,
        subtopic_taggable_deadline: null,
        type: 'normal',
        starts_at: null,
        ends_at: null,
        last_active_at: '2022-05-30 10:21:47 +0800',
        competition_info: {
          competition_tutor_count: 0,
          answer_options_count: 0,
          competition_answers: [],
          competition_answers_type: 'alphabet',
          competition_end_time: null,
          tutor_competition_answered_status: null,
        },
        matching_info: {
          matching_end_at: null,
          matching_candidates_pics: [],
          tutor_matching_state: 'not_yet_join',
        },
        is_auto_set_public: false,
        auto_set_public_at: '2022-05-30 10:36:47 +0800',
      },
    ],
  },
};

export const pickQuestionNotFound = {
  status: 'error',
  error_code: '20-300-0007-000',
  response: '未找到問題紀錄。',
  error_display: {
    title: null,
    message: '未找到問題紀錄。',
    positive_btn: null,
    negative_btn: null,
    dismiss_btn: null,
  },
  error_message: '未找到問題紀錄。',
  data: {},
  requires_logout: false,
};

export const pickQuestionHadPicked = {
  status: 'error',
  error_code: '20-310-0009-013',
  response: '可能是學生取消預約，或已有其他老師接下預約',
  error_display: {
    title: null,
    message: '可能是學生取消預約，或已有其他老師接下預約',
    positive_btn: null,
    negative_btn: null,
    dismiss_btn: null,
  },
  error_message: '可能是學生取消預約，或已有其他老師接下預約',
  data: {},
  requires_logout: false,
};



// WEBPACK FOOTER //
// ./src/mock/response/tutor.js